import { TranslationRecord } from '../../TranslationRecord';

export const enTranslations: TranslationRecord = {
  ERROR: 'Something went wrong',
  PHONE_NUMBER: 'Phone number',
  SELECT_FILE_FROM_DISK: 'Select file from disk',
  UPLOAD_IMAGE: 'Upload image from the scene of the incident',
  DESKTOP_UPLOAD_IMAGE_TITLE: 'Drag and drop file here or click to add file from your disk',
  DESKTOP_UPLOAD_IMAGE_ADDITIONAL_TEXT: 'Available formats .jpg, .png, .bmp max. 4MB',
  MOBILE_UPLOAD_IMAGE_TITLE: 'Take a photo or Add a file from your disk',
  FORM_TITLE: 'Order Assistance by uploading a photo from the scene of the incident',
  CONSENT_TO_CONTACT_AND_READ_INFO: 'I consent to being contacted by telephone and I have read',
  INFORMATION_REGARDING_DATA_PROCESSING: 'the information regarding data processing.',
  PHONE_NUMBER_HELPER_TEXT: 'It will allow us to contact you quickly',
  INFO_CARD_TITLE: 'How does it work?',
  INFO_CARD_CONTENT_1:
    '1. You add a photo from the accident with a visible license plate. We recognize the place of the incident from the photo.',
  INFO_CARD_CONTENT_2: '2. You will receive information about help by phone.',
  NEXT: 'Next',
  MAKE_PHOTO_INSTRUCTION_TITLE: 'See how to take a photo',
  MAKE_PHOTO_INSTRUCTION_CONTENT:
    'Take a photo from the front or back of the vehicle, so that the license plate is visible in the photo.',
  YOUR_REPORT_NR: 'Your application nr',
  HAS_BEEN_RECEIVED_FOR_PROCESSING: 'has been accepted for processing',
  WE_WILL_CONTACT_WITH_YOU_WITHIN_A_FEW_MINUTES: 'We will call you within a **few minutes** to arrange assistance.',
  RECEIVE_LINK_VIA_SMS:
    'After the conversation, you will receive a link via SMS to track the roadside assistance route.',
  CAN_NOT_READ_PLATE_NUMBER_FROM_IMAGE: 'The license plates were not read correctly from the photo',
  CAN_NOT_READ_LOCATION_DATA: 'The location of the incident was not read correctly',
  TRY_AGAIN_TO_LOAD_PHOTO_OR_MAKE_CALL:
    'Make sure the license plates are **clearly visible** and take a photo again or call us to order Assistance by phone.',
  MAKE_PHOTO_AGAIN: 'Take the photo again',
  MAKE_CALL_AT: 'Make call at',
  MAKE_CALL_TO_US: 'Call us',
  CAN_NOT_READ_LOCALIZATION: 'The location of the incident site has not been read',
  MAKE_CALL_TO_ORDER_ASSISTANCE: 'Call us to order Assistance.',
  REQUIRED: 'Required',
  FILE_TOO_LARGE: 'Uploaded file is too large. Maximum size is 4 MB.',
};
